<template lang="pug">
component(
	v-for='dialogConfig in dialogConfigs'
	:is='dialogConfig.component'
	v-bind='dialogConfig.props'
	v-on='dialogConfig.listeners || {}'
	:key='dialogConfig.id'
)
</template>

<script setup>

import {useDialogManagerStore} from '@/stores/dialog-manager';
import { storeToRefs } from 'pinia';

const dialogManagerStore = useDialogManagerStore();

const {dialogConfigs} = storeToRefs(dialogManagerStore);

</script>